import React from 'react'
import { Container } from './ProjectAbout.styled'

function ProjectAbout({ about }) {
  return about && <Container dangerouslySetInnerHTML={{ __html: about }} />
}

export default ProjectAbout
